module.exports = __webpack_public_path__ + "img/Apoptosis-MELA_GSE185386.d206b4bb.png";